import styles from './Background.desktop.module.css';
import { useTranslation } from 'react-i18next';
import { useBackgroundController } from '../Background.controller.ts';
import isAdmin from '../../../security/IsAdmin.ts';

export default function BackgroundDesktopView() {
  const { t } = useTranslation();
  const { market, marketX, marketY, data } = useBackgroundController();

  return (
    <>
      {market?.configuration?.enableMarketDrawing &&
        market?.configuration?.filenameMarketDrawing !== '' &&
        isAdmin() &&
        data && (
          <img
            src={data}
            width={marketX}
            height={marketY}
            className={styles.container}
            alt={t('ui.noImageFound')}
          />
        )}
      {(!market?.configuration?.enableMarketDrawing ||
        market?.configuration?.filenameMarketDrawing === '' ||
        !isAdmin()) && (
        <svg
          width="100%"
          height="100%"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.container}
        >
          <defs>
            <pattern id="dot-pattern" width="30" height="30" patternUnits="userSpaceOnUse">
              <rect width="30" height="30" fill="#F2F2F5" />
              <circle cx="15" cy="15" r="2" fill="#dcdcdc" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dot-pattern)" />
        </svg>
      )}
    </>
  );
}
